"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _layout = require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n  white-space: nowrap;\n  margin-left: auto;\n  align-items: center;\n  padding-left: 12px;\n\n  > * {\n    margin-left: 12px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Actions = (0, _styledComponents.default)(_layout.Box).withConfig({
  displayName: "Actions",
  componentId: "mymp0f-0"
})(_templateObject());
Actions.propTypes = {
  children: _propTypes.default.node.isRequired
};
Actions.defaultProps = {
  children: null
};
var _default = Actions;
exports.default = _default;